import { ApiEndPoint } from "../../network/api_end_point";
import { apiCaller, getToken } from "../../network/network_helper";
import {showErrorToast} from "../../components/toast/error_toast";

const apiEndPoint = new ApiEndPoint();

export const unassignDriverApiCall=async(taskId)=>{
    try{
        const listTaskId=[];
        listTaskId.push(taskId);
        const token=getToken();
        const response = await apiCaller(apiEndPoint.hawkBaseUrl+apiEndPoint.unassignDriver,{
            method:'POST',
            headers:{
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
            params:{
                source:apiEndPoint.source
            },
            data:{
                'task_ids': listTaskId,
            }
        })
        return response;

    }
    catch(e){
        throw e;
    }
}